import { Location } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router'; 
import { environment } from '../../../../environments/environment';
import { HasUnsavedChanges } from '../../../route-guards/unsaved-changes.route-guard';
import { AccessibilityHelper } from '../../../shared/accessibility.helper';
import { FormFillerComponent } from '../../../shared/components/form-filler/form-filler.component';
import { ButtonConfig, SvgViewBox } from '../../../shared/components/list-view/list-view-button-config.model';
import { ListItemDragActionData } from '../../../shared/components/list-view/list-view-drag-action.model';
import { ListItemMoveData } from '../../../shared/components/list-view/list-view-item-move-action';
import { TrashConfig, TrashDeleteEvent } from '../../../shared/components/list-view/list-view-trash-config.model';
import { ListViewEnum, ListViewHelper } from '../../../shared/components/list-view/list-view.helper';
import { FavoriteInfo } from '../../../shared/components/toggle-favorite/toggle-favorite.component';
import { ImportDragDropComponent } from '../../../shared/dialogs/import-drag-drop/import-drag-drop.component';
import { Title } from '@angular/platform-browser';
import { IconFormatEnum } from '../../../shared/enums/icon-format.enum';
import { ItemTypeEnum } from '../../../shared/enums/item-type.enum';
import { SvgIconNameEnum } from '../../../shared/enums/svg-icon-name.enum';
import { IHasIdAndName } from '../../../shared/interfaces/has-id-and-name.interface';
import { IListItem, IListItemManager } from '../../../shared/interfaces/ilist-item.interface';
import { DataCollection } from '../../../shared/models/site-content/data-collection.model';
import { Folder } from '../../../shared/models/site-content/folder.model';
import { FormInstance } from '../../../shared/models/site-content/form-instance.model';
import { CommunicationService } from '../../../shared/services/communication.service';
import { CurrentSiteService } from '../../../shared/services/current-site.service';
import { CurrentFolderService } from '../../../shared/services/current-folder.service';
import { DeleteOnConfirmDialogService } from '../../../shared/services/delete-on-confirm-dialog.service';
import { DocumentPublishingService } from '../../../shared/services/document-publishing.service';
import { FolderService } from '../../../shared/services/folder.service';
import { FormInstanceService } from '../../../shared/services/form-instance.service';
import { RoleService } from '../../../shared/services/role.service';
import { UtilityHelper } from '../../../shared/utility.helper';
import {
    FOLDER,
    FORM_INSTANCE,
    VIEW,
    SAVE_FORM_INSTANCE,
    RESET_FORM_INSTANCE,
    PUBLISH,
    PRINT_FORM_INSTANCE,
    BULK_WORKFLOW,
    HISTORY,
    SUBSCRIBE,
    IMPORT_FORM_INSTANCE_DATA,
    IMPORT_FORM_INSTANCE_FILES,
    EXPORT_FORM_INSTANCE_FILES,
    EXPORT_TO_EXCEL,
    FORM,
    UP_ONE_LEVEL,
    TREE,
    INFO,
    ROLES,
    FAVORITE,
    TRUE,
    FALSE,
    FoldersFormInstancesFavoritesButtonConfig,
    ViewAndManageRolesButtonConfig
} from './structure.extras';
import { FilesDroppedOnStructureEvent } from './structure.file-drop.event';
import { ClipboardService } from '../../../shared/services/clipboard.service';
import { MoveListItemDialog } from '../../../shared/dialogs/move-list-item/move-list-item.dialog';
import { ScheduledEventsDialog } from '../../../shared/dialogs/scheduled-events-dialog/scheduled-events.dialog';
// 05-10-2022 note:  using the following dialogue class for testing only.
import { ExportDataDialogConfig, ExportDataDialogAction, ExportDataDialog } from '../../../shared/dialogs/export-data/export-data.dialog';
import { ExportSiteDialog } from '../../../shared/dialogs/export-site/export-site.dialog';
import { DragDropEnum } from '../../../shared/enums/drag-drop.enum';
//import { ExcelExportService } from '../../../shared/services/excel-export.service';
//import { AsyncJobService } from '../../../shared/services/async-job.service';
import { ExportFormDataDialogAction, ExportFormDataDialogConfig, ExportFormDataDialog } from '../../../shared/dialogs/export-form-data/export-form-data.dialog';
import { IContextMenuItem } from '../../../shared/interfaces/icontext-menu-item.interface';
import { StructureItemContextMenuData } from '../../../shared/models/structure/item-context-menu';
import { StructureListViewContextMenuData } from '../../../shared/models/structure/list-view-context-menu';
import { MainPanelContextMenuData } from '../../../shared/models/structure/main-panel-context-menu';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import {
    ExportFormInstanceFilesClickHandler,
    ExportToExcelClickHandler,
    ImportFormInstanceFilesClickHandler,
    NewFolderClickHandler,
    NewFormClickHandler,
    PrintFormInstanceClickHandler,
    PublishClickHandler,
    //ResetFormInstanceClickHandler,
    //SaveFormInstanceClickHandler,
    ShowHistoryClickHandler,
    ToggleShowHideClickHandler,
    SubscribeClickHandler,
    BulkWorkflowStateChangeClickHandler,
    //FieldEditorClickHandler
} from '../../../shared/models/structure/page-button-config-click-handlers';
import { EditStructureItemPropertiesClickHandler, ViewStructureItemPropertiesClickHandler, EditStructureRolesClickHandler, ToggleStructureFavoriteClickHandler } from '../../../shared/models/structure/item-button-config-click-handlers';
import { IButtonConfig, IButtonConfigClickHandler } from '../../../shared/components/list-view/list-view-button-config.model';
import { IDrawerComponentLiaison } from '../../../shared/interfaces/idrawer-component-liaison';
import { CurrentUserService } from '../../../security/current-user.service';
import { FolderFormInstanceTreeService } from '../../../shared/services/folder-form-instance-tree.service';
import { ScriptableBaseComponent } from '../../../shared/components/scriptable-base/scriptable-base.component';
import { BrowserStorageService } from '../../../shared/services/browserstorage.service';
//import { IconDisplayStyle } from '../../../shared/enums/icon-display-style.enum';
import { ComponentHierarchyService } from '../../../shared/services/component-hierarchy.service';
import { FormRendererComponent } from '../../../shared/components/form-renderer/form-renderer.component';
import { IListViewLiaison } from '../../../shared/components/list-view/ilist-view-liaison.interface';
import { StructureComponentListViewLiaison } from '../../../shared/models/structure/list-view-liaison.model';
import { QueryParamsService } from '../../../shared/services/query-params.service';
import { ConfigureStructureFields } from '../../../shared/models/structure/configure-structure-fields.model';

// Tree related properties
class StructureTreeProperties {
    public treeIsStale: boolean = false;
    // folderPath is supplied as the "path" @Input property of the Tree. The tree uses it to expand to and highlight the selected node.
    // Values are of the form "folder_<id>" and "form-instance_<id>" which matches the form of TreeNode's key property
    public folderPath: string[];
}

// Define some constants.
const SAVE_FORM_INSTANCE_TEXT: string = 'Save Form';
const RESET_FORM_INSTANCE_TEXT: string = 'Discard Edits';
const PRINT_FORM_INSTANCE_TEXT: string = 'Print Form';
const NEW_FOLDER_TEXT: string = 'New Folder';
const NEW_FORM_TEXT: string = 'New Form';
const PUBLISH_BTN_TEXT: string = 'Publish';
const DISPLAY_TREE_TEXT: string = 'Display Tree';
const FORM_DETAILS: string = 'Form Details';
const IMPORT_DATA_FILES_BTN_TEXT: string = 'Upload (Displays for System Admins Only)'; //'Import Forms';
const EXPORT_DATA_FILES_BTN_TEXT: string = 'Download Site (Displays for System Admins Only)'; //'Export Forms';
const EXPORT_TO_EXCEL_BTN_TEXT: string = 'Export to Excel';
const EXPORT_IMPORT_EXCEL_BTN_TEXT: string = 'Export/Import Excel';
const BULK_WORKFLOW_BTN_TEXT = 'Bulk Workflow';

export class StructureListViewData {
    public listItems: IListItem[];
    public totalListCount: number;
}

@Component({
    selector: 'app-structure',
    templateUrl: './structure.component.html',
    styleUrls: ['./structure.component.scss'],
    standalone: false
})
export class StructureComponent extends ScriptableBaseComponent implements OnInit, AfterViewInit, HasUnsavedChanges {
    // Instance data.
    private currentFolder: Folder;
    private currentFormInstance: FormInstance;
    private showFormInstance: boolean = false;
    private detailsMode: string;
    private listItems: IListItem[];
    private buttonConfig: any;
    private rootFolder: Folder;
    private filterTerm: string;
    private structureResetAt: Date;

    // Note:  need to discuss the following with Paul or perhaps someone else.
    // Changing the following nine new properties to private access as a prelude to remove them altogether.
    // QUESTION:  if it is still the case that only one folder or form instance can be selected at one time,
    //            or if this true with regard to invoking a side drawer to edit an object's properties, can
    //            we merge the following two properties into one?
    private selectedFolder: Folder;
    private selectedFormInstance: FormInstance;

    public draggedItems: ListItemDragActionData; // Why is this public?

    private selectedItems: IListItem[];
    private treeProperties: StructureTreeProperties = new StructureTreeProperties();

    private favoritesButtonConfig: FoldersFormInstancesFavoritesButtonConfig = null;
    private viewAndManageRolesButtonConfig: ViewAndManageRolesButtonConfig = null;

    @ViewChild('formFiller') formFiller: FormFillerComponent;

    // Context menu properties.
    private pageContextMenuPosition = { x: '0px', y: '0px' };
    @ViewChild('listViewItemContextMenuComponent') listViewItemContextMenuComponent: ContextMenuComponent;
    @ViewChild('listViewContextMenuComponent') listViewContextMenuComponent: ContextMenuComponent;
    @ViewChild('mainPanelContextMenuComponent') mainPanelContextMenuComponent: ContextMenuComponent;

    private totalListCount: number;
    private showHistory: boolean = false;
    //private formInstanceHistory: FormInstance[];

    private itemContextMenuData: StructureItemContextMenuData = null;
    private pageContextMenuData: StructureListViewContextMenuData = null;
    private mainPanelContextMenuData: MainPanelContextMenuData = null;

    // There are a number of implementations of IDrawerComponentLiaison and which one is active at any one time depends on which
    // drawer-related button has been clicked. The drawer-related buttons are configured in the "list_items" block in setupButtonConfigForListItems
    // The purpose of these liaison classes is to liaise between the structure component here, and a component rendered in an open drawer
    private drawerComponentLiaison: IDrawerComponentLiaison = null;

    private listViewLiaison: StructureComponentListViewLiaison = new StructureComponentListViewLiaison(this, ListViewHelper.NO_SORT, ListViewEnum.STRUCTURE);
    private currentUserIsSysAdmin: boolean;
    private configuredStructureFields: ConfigureStructureFields = ConfigureStructureFields.createEmptyConfig();

    // Constructor.
    public constructor(
        private location: Location,
        private currentSiteService: CurrentSiteService,
        private currentUserService: CurrentUserService,
        private currentFolderService: CurrentFolderService,
        private communicationService: CommunicationService,
        private documentPublishingService: DocumentPublishingService,
        private folderService: FolderService,
        private roleService: RoleService,
        private formInstanceService: FormInstanceService,
        private clipboardService: ClipboardService,
        private route: ActivatedRoute,
        private router: Router, 
        public dialog: MatDialog,
        private deleteOnConfirmDialogService: DeleteOnConfirmDialogService,
        private folderTreeService: FolderFormInstanceTreeService,
        private localStorageService: BrowserStorageService,
        private readonly titleService: Title,
        private componentHierarchyServiceForMenuClass: ComponentHierarchyService,
        private queryParamsService: QueryParamsService,
        elForBaseClass: ElementRef) {
        super(elForBaseClass);
        let toolbarNamesMap = {
            'material-post-add': 'Add Form',
            'material-new-folder': 'Add Folder',
            'material-file-upload': 'Upload Form Data',
            'material-file-download': 'Download Form Data',
            'material-export-notes': 'Publish',
            'notification-add': 'Add a Notification',
            'trash': 'Delete',
            'account_tree': 'Show/Hide Tree',
            'sort_by_alpha': 'Sort',
            'view_module': 'View Mode'
        };
        this.setupSearchForListViewElements(toolbarNamesMap, { 'folder': 'Folder', 'article': 'Form' });
        let formInstanceToolbarNamesMap =
        {
            // TO DO:  ADD MAPPINGS HERE.
        };

        // Create my context menu data.
        this.itemContextMenuData = new StructureItemContextMenuData(this, this.dialog, this.clipboardService, this.folderService, this.currentSiteService, this.formInstanceService, this.currentUserService);
        this.pageContextMenuData = new StructureListViewContextMenuData(this);
        this.mainPanelContextMenuData = new MainPanelContextMenuData(this, this.clipboardService, this.FolderService);
    }

    private setupButtonConfigForListItems() {
        this.currentFolder = this.currentFolderService.Folder;
        this.favoritesButtonConfig =
            new FoldersFormInstancesFavoritesButtonConfig(
                new ButtonConfig('Toggle Favorite (Display for System Admins Only -- VNEXT-756)', FAVORITE, SvgIconNameEnum.STAR_UNFILLED, IconFormatEnum.SVG_ICON),
                SvgIconNameEnum.STAR_FILLED_BLUE,
                this.currentFolder.childFolders,
                this.currentFolder.formInstances);

        this.viewAndManageRolesButtonConfig = new ViewAndManageRolesButtonConfig(
            new ButtonConfig('View and Manage Roles', ROLES, SvgIconNameEnum.MANAGE_ROLES, IconFormatEnum.SVG_ICON),
            SvgIconNameEnum.MANAGE_ROLES_NOT_INHERITED,
            SvgIconNameEnum.MANAGE_ROLES_DISABLED,
            this.CurrentFolder.childFolders
        );

        // Construct my buttons configuration.
        //VNEXT-1430: KLW - Styling fixes
        let svgInlineStyles: string = "height: 36px; width: 36px; margin-top: 20px;";
        let excelSvgInlineStyles: string = "height: 48px; width: 48px; margin-top: 20px;"; 
        let matIconInlineStyles: string = "transform: scale(1.4,1.4); margin-top: 10px; margin-bottom: 0px;";

        let canCreateFolder = this.currentFolder.canCreateFolder;
        let canCreateForm = this.currentFolder.canCreateForm;

        let rightButtonConfig = [
            new ButtonConfig(NEW_FORM_TEXT, FORM, 'material-post-add', IconFormatEnum.SVG_ICON, !canCreateForm).setInlineStyles(svgInlineStyles)
                .setButtonClickHandler(new NewFormClickHandler(this)),
            new ButtonConfig(NEW_FOLDER_TEXT, FOLDER, 'material-new-folder', IconFormatEnum.SVG_ICON, !canCreateFolder).setInlineStyles(svgInlineStyles)
                .setButtonClickHandler(new NewFolderClickHandler(this))
        ];
        // Deal with adding buttons that can be configured to be hidden
        if (this.rootFolder != this.currentFolder) {

            // VNEXT-756 - hide from non System Admins
            if (!this.currentFolder.HideUpload && this.currentUserIsSysAdmin) {
                rightButtonConfig.push(new ButtonConfig(IMPORT_DATA_FILES_BTN_TEXT, IMPORT_FORM_INSTANCE_FILES, 'material-file-upload', IconFormatEnum.SVG_ICON)
                    .setInlineStyles(svgInlineStyles).setButtonClickHandler(new ImportFormInstanceFilesClickHandler(this))
                );
            }
            // VNEXT-756 - hide from non System Admins
            if (!this.currentFolder.HideDownload && this.currentUserIsSysAdmin) {
                rightButtonConfig.push(
                    new ButtonConfig(EXPORT_DATA_FILES_BTN_TEXT, EXPORT_FORM_INSTANCE_FILES, 'material-file-download', IconFormatEnum.SVG_ICON)
                        .setInlineStyles(svgInlineStyles).setButtonClickHandler(new ExportFormInstanceFilesClickHandler(this))
                );
            }
            if (!this.currentFolder.HideExportToExcel) {
                let btnText = EXPORT_TO_EXCEL_BTN_TEXT;
                btnText = EXPORT_IMPORT_EXCEL_BTN_TEXT;

                rightButtonConfig.push(new ButtonConfig(btnText, EXPORT_TO_EXCEL, 'black-and-white-excel', IconFormatEnum.SVG_ICON)
                    .setInlineStyles(excelSvgInlineStyles).setButtonClickHandler(new ExportToExcelClickHandler(this))
                );
            }
        }

        rightButtonConfig.push(
            new ButtonConfig(PUBLISH_BTN_TEXT, PUBLISH, 'material-export-notes', IconFormatEnum.SVG_ICON).setInlineStyles(svgInlineStyles)
                .setButtonClickHandler(new PublishClickHandler(this)),
            new ButtonConfig(BULK_WORKFLOW_BTN_TEXT, BULK_WORKFLOW, 'timeline', IconFormatEnum.MAT_ICON, !this.currentFolder.canPerformBulkWorkflowUpdate).setInlineStyles(matIconInlineStyles)
                .setButtonClickHandler(new BulkWorkflowStateChangeClickHandler(this))
        );

        //VNEXT-1495 hide Subscribe icon in form instance view
        //rightButtonConfig.push(
        //    new ButtonConfig('Subscribe', 'subscribe', 'notification-add', IconFormatEnum.SVG_ICON).setInlineStyles(svgInlineStyles)
        //        .setButtonClickHandler(new SubscribeClickHandler(this))
        //);

        let formInstanceButtonsConfig = [
            //VNEXT-632 hide save and reset buttons for now
            //new ButtonConfig(SAVE_FORM_INSTANCE_TEXT, SAVE_FORM_INSTANCE, 'material-save', IconFormatEnum.SVG_ICON).setInlineStyles(svgInlineStyles).setButtonClickHandler(new SaveFormInstanceClickHandler(this)),
            //new ButtonConfig(RESET_FORM_INSTANCE_TEXT, RESET_FORM_INSTANCE, 'material-restart-alt', IconFormatEnum.SVG_ICON).setInlineStyles(svgInlineStyles).setButtonClickHandler(new ResetFormInstanceClickHandler(this, this.dialog)),
            new ButtonConfig(PUBLISH_BTN_TEXT, PUBLISH, 'material-export-notes', IconFormatEnum.SVG_ICON).setInlineStyles(svgInlineStyles).setButtonClickHandler(new PublishClickHandler(this)),
            new ButtonConfig('History', 'history', 'material-file-copy', IconFormatEnum.SVG_ICON).setInlineStyles(svgInlineStyles).setButtonClickHandler(new ShowHistoryClickHandler(this)),
            new ButtonConfig('Form Details', FORM_DETAILS, 'info').setButtonClickHandler(new ViewStructureItemPropertiesClickHandler(this))
        ];

        if (!this.currentFolder.HidePrintForm) {
            formInstanceButtonsConfig.splice(1, 0,
                new ButtonConfig(PRINT_FORM_INSTANCE_TEXT, PRINT_FORM_INSTANCE, 'material-print', IconFormatEnum.SVG_ICON).setInlineStyles(svgInlineStyles).setButtonClickHandler(new PrintFormInstanceClickHandler(this))
            );
        }

        //VNEXT-1495 hide Subscribe icon in Structure
        //formInstanceButtonsConfig.splice(2, 0,
        //    new ButtonConfig('Subscribe', 'subscribe', 'notification-add', IconFormatEnum.SVG_ICON)
        //        .setInlineStyles(svgInlineStyles)
        //        .setButtonClickHandler(new SubscribeClickHandler(this)));

        let buttonSet = [];
        buttonSet.push(new ButtonConfig('View Details', INFO, 'info').setButtonClickHandler(new EditStructureItemPropertiesClickHandler(this)));
        if (!this.currentSiteService.Site.useSimplifiedPermissionsModel) {
            buttonSet.push(this.viewAndManageRolesButtonConfig.setButtonClickHandler(new EditStructureRolesClickHandler(this)));
        }

        this.buttonConfig = {
            right: rightButtonConfig,
            // Drawer-related buttons whose click handlers are responsible for setting this.drawerComponentLiaison (see note on that property above)
            // these buttons open the drawer to configure various properties of Folders/FormInstances
            // Their click handlers instantiate implementations of IDrawerComponentLiaison which are used to liaise between the structure component here
            // and the components rendered inside an open drawer
            // When a button is clicked the following happens:
            // 1) a derivative of StructureButtonConfigClickHandlerBase gets created and passed as the ButtonConfig's click handler
            // 2) when clicked, among other things, the handler will create an instance of a IDrawerComponentLiaison and set structure component's drawerComponentLiaison with it
            //    (notice that click handler's constructors take "this" so that can call back to the structure component and set its drawerComponentLiaison property)
            // 3) this.drawerComponentLiaison is supplied as an input variable to drawer components in structure's html template...
            //    Example: <app-folder-details ... [drawerComponentLiaison]= "this.DrawerComponentLiaison" > </app-folder-details>
            // 4) When the drawer components ngOnInit() is called, it takes the drawerComponentLiaison passed as input to it in step 3, and passes itself to it to that the liaison can
            //    perform any configuration it needs to on it, and subscribe to any of its events so that it can handle them (this happens in DrawerComponentBase.ngOnInit())
            // Thus, it's the structure's drawerComponentLiaison that performs calls to the backend to perform any updates initiated from a drawer componoent, not the drawer component itself
            item_actions: buttonSet,
            trash: (this.currentUserIsSysAdmin ? new TrashConfig(true) : null), // VNEXT-756 - show to system admins only
            navigation: [
                new ButtonConfig(DISPLAY_TREE_TEXT, TREE, 'account_tree').setInlineStyles(svgInlineStyles).setButtonClickHandler(new ToggleShowHideClickHandler(this, this.folderTreeService))
            ],
            formInstanceButtons: formInstanceButtonsConfig
        };

        // FOR VNEXT-756
        if (this.currentUserIsSysAdmin) {
            this.buttonConfig.item_actions.push(this.favoritesButtonConfig.setButtonClickHandler(new ToggleStructureFavoriteClickHandler(this)));
        }

        // Conditionally add some additional buttons.
        if (this.ShowAppChrome && this.ShowStructure) {
            let showTreeConfig = new ButtonConfig(DISPLAY_TREE_TEXT, TREE, 'account_tree').setInlineStyles(svgInlineStyles).setButtonClickHandler(new ToggleShowHideClickHandler(this, this.folderTreeService));
            this.buttonConfig.formInstanceButtons.splice(4, 0, showTreeConfig);
        }
    }

    // Life cycle methods.
    public ngOnInit() {
        super.ngOnInit();

        this.currentUserIsSysAdmin = this.currentUserService.user.isSystemAdmin;

        let param = this.route.snapshot.params.showHistory;
        this.showHistory = (param == 'true');
        this.route.parent.parent.data
            .subscribe((data: { currentSite: DataCollection }) => {
                this.route.data
                    .subscribe((data: { folder: Folder, formInstance: FormInstance }) => {
                        super.reFindScriptableElements(); // For UI testing

                        // bit of a hack...this showFormInstance thing forces the child component (app-form-filler)
                        // to be destroyed when loading FormInstances from the Tree so they can be reinitialized.
                        // Without it Form Instances with blank elements do not get initialized and this can mess up
                        // the content they display
                        this.showFormInstance = false;
                        UtilityHelper.runWhenStackClear(() => {
                            this.showFormInstance = true;
                        });

                        // because we are subscribed, this code runs every time the route
                        // updates and there is new data
                        this.showHistory = false;
                        this.currentFormInstance = data.formInstance;

                        let urls: string[] = this.router.url.split('/');
                        this.currentFolder = this.currentFolderService.Folder;

                        this.totalListCount = this.currentFolder.totalChildFolderCount + this.currentFolder.totalFormInstanceCount;
                        this.structureReset();

                        this.setRootFolder();
                        this.setupButtonConfigForListItems();
                        this.setListItems();
                        this.setFolderPathForTree();
                        this.updateSkipNav();
                        //this.enableDisableButtons();  // pharvey - 12/15/2023 - discovered this has no effect now that ButtonConfigs take care of button disabling
                        // leaving it here for now in case there's some issue and it needs to be quickly reinstated
                        this.folderTreeService.openTreeIfPinned();
                        this.trackPageView();
                    });
            });
        this.titleService.setTitle(this.route.snapshot.data['title'] + ' for ' + this.site.name);

        // Begin https://maxjira.max.gov/browse/VNEXT-1340 updates.
        if ((this.currentSiteService.Site.hideStructureMetadataFieldsJsonConfig != null) && (this.currentSiteService.Site.hideStructureMetadataFieldsJsonConfig.trim() != '')) {
            // We have a configuration, so parse it.
            this.configuredStructureFields = ConfigureStructureFields.parseFromJson(this.currentSiteService.Site.hideStructureMetadataFieldsJsonConfig)
        }
        // End https://maxjira.max.gov/browse/VNEXT-1340 updates.
    }

    public ngAfterViewInit(): void {
        // Note:  it is convenient to have this method as at this point
        //        any @ViewChild or @ViewChildren properties should be resolved.
        return;
    }

    // Returns true if the given button is relevant for display of a FormInstance
    public isFormInstanceButton(button): boolean {
        return button.label != NEW_FOLDER_TEXT && button.label != NEW_FORM_TEXT
    }

    //VNEXT-614: KLW - Adding property getter to determine read only text
    public get ReadOnlyText(): string {
        if (!this.currentFormInstance.canEdit)
            return " --Read Only Due to Workflow State--";
        else
            return "";
    }

    public get ShowStructure(): boolean {
        return this.currentSiteService.Site.currentUserCanSeeStructure;
    }

    public get DefaultSort(): string {
        return ListViewHelper.NO_SORT;
    }

    public get ColumnSortingConfig(): any {
        let config = null;
        let json = this.localStorageService.get('structure_grid_sort-state');
        if (json) {
            config = JSON.parse(json);
        }
        return config;
    }

    public get ColumnSortingIsOff(): boolean {
        let res = true;
        let config = this.ColumnSortingConfig;
        if (config) {
            res = config.active == ListViewHelper.NO_SORT;
        }
        return res;
    }

    public get CurrentFormInstanceStatus(): string {
        return this.currentFormInstance.currentWorkflowState;
    }

    public get StructureResetAt(): Date {
        return this.structureResetAt;
    }

    public get FilterTerm(): string {
        return this.filterTerm;
    }
    public set FilterTerm(value: string) {
        this.filterTerm = value;
    }

    public get TotalListCount(): number {
        return this.totalListCount;
    }
    public set TotalListCount(value: number) {
        this.totalListCount = value;
    }

    public get FolderName(): string {
        return !this.currentFolder.parentFolderId ? 'Site Structure' : this.currentFolder.name;
    }

    public get listType(): string {
        return ListViewEnum.STRUCTURE;
    }

    public get ShowHistory(): boolean {
        return this.showHistory;
    }
    public set ShowHistory(show: boolean) {
        this.showHistory = show;
    }
    // Returns true if drawerComponentLiaison is currently set to a Liaison class that manages Folder details
    // drawerComponentLiaison gets set inside a drawer-related button click handler
    public get ShowFolderProperties(): boolean {
        return this.showDrawerWithTag('app-folder-details');
    }

    public get ShowFormInstanceProperties(): boolean {
        return this.showDrawerWithTag('app-form-instance-details');
    }

    public get ShowRoles(): boolean {
        return this.showDrawerWithTag('app-role-viewer');
    }

    public get ShowToggleFavorite(): boolean {
        return this.showDrawerWithTag('app-toggle-favorite');
    }

    public get ShowFormInstance(): boolean {
        return this.showFormInstance && this.CurrentFormInstance != null;
    }

    // If there is no FormInstance to display, then display list of Folders / FormInstances
    public get ShowFolderList(): boolean {
        return this.CurrentFormInstance == null;
    }

    public get DetailsDrawerTitle(): string {
        if (this.ShowFolderProperties) {
            return 'Folder Details';
        } else if (this.ShowFormInstanceProperties) {
            return 'Form Details';
        } else if (this.ShowRoles) {
            return 'Folder Permissions';
        } else if (this.ShowToggleFavorite) {
            return this.FavoriteDrawerTitle;
        }
    }

    public get ShowAppChrome(): boolean {
        return !this.queryParamsService.HideAppChrome;
    }

    // Accessor methods called by my HTML code.
    public get site() {
        return this.currentSiteService.Site;
    }

    public get ListItems(): IListItem[] {
        return this.listItems;
    }
    // Note:  it is obviously not ideal having the following setter, but it is needed for the time being
    //        in order to move a lot of code out of this component class in order to simplify it.
    public set ListItems(value: IListItem[]) {
        this.listItems = value;
    }

    public get ButtonConfig(): any {
        return (this.buttonConfig);
    }

    public get PinTreeOpen(): boolean {
        return this.folderTreeService.TreeIsPinnedOpen;
    }

    // REPLACE WITH CALL TO Tree Service
    public get ShowTree(): boolean {
        return this.folderTreeService.ShowTree;
    }

    public get TreeIsStale(): boolean {
        return this.treeProperties.treeIsStale
    }
    public set TreeIsStale(value: boolean) {
        this.treeProperties.treeIsStale = value;
    }

    public get CurrentFolder(): Folder {
        return (this.currentFolder);
    }

    public get DraggedItems(): ListItemDragActionData {
        return this.draggedItems;
    }
    public set DraggedItems(value: ListItemDragActionData) {
        this.draggedItems = value;
    }

    public get ListViewLiaison(): IListViewLiaison {
        return this.listViewLiaison;
    }

    public get RootFolder(): Folder {
        return (this.rootFolder);
    }
    public get RolesTargetFolder(): Folder {
        let rolesTargetFolder: Folder = null;

        if ((this.drawerComponentLiaison != null) && (this.drawerComponentLiaison.HandlesDrawerComponentTag == 'app-role-viewer') && this.drawerComponentLiaison.LiaisonHasInitialized) {
            let rolesDrawerComponentLiason: EditStructureRolesClickHandler = <EditStructureRolesClickHandler>this.drawerComponentLiaison;

            rolesTargetFolder = rolesDrawerComponentLiason.RolesTargetFolder;
        }

        return rolesTargetFolder;
    }
    public get SelectedItems(): IListItem[] {
        return this.selectedItems;
    }

    public get CurrentFormInstance(): FormInstance {
        return (this.currentFormInstance);
    }
    public set CurrentFormInstance(formInstance: FormInstance) {
        this.currentFormInstance = formInstance;
    }

    public get PageContextMenuPositionX(): string {
        return this.pageContextMenuPosition.x;
    }
    public get PageContextMenuPositionY(): string {
        return this.pageContextMenuPosition.y;
    }
    public get UserCanExportStructureInstances(): boolean {
        let bUserCanExport: boolean = false;

        if ((this.listViewItemContextMenuComponent != null) && (this.listViewItemContextMenuComponent.ContextItem != null)) {
            let contextItem: IListItem = this.listViewItemContextMenuComponent.ContextItem;

            bUserCanExport = (contextItem.getType() == FormInstance.TypeName);
        }

        return (bUserCanExport);
    }

    public get UserCanImportStructureInstances(): boolean {
        return (this.UserCanExportStructureInstances);
    }

    public get ItemContextMenuData(): IContextMenuItem[] {
        return this.itemContextMenuData.ItemContextMenuData;
    }
    public get PageContextMenuData(): IContextMenuItem[] {
        return this.pageContextMenuData.PageContextMenuData;
    }
    public get MainPanelContextMenuData(): IContextMenuItem[] {
        return this.mainPanelContextMenuData.MenuData;
    }

    public get ConfiguredStructureFields(): ConfigureStructureFields {
        return this.configuredStructureFields;
    }
    // End methods called by my HTML code.

    // Handle control events.
    public get Dialog(): MatDialog {
        return this.dialog;
    }
    public get Router(): Router {
        return this.router;
    }
    public get DocumentPublishingService(): DocumentPublishingService {
        return this.documentPublishingService;
    }
    public get CurrentSiteService(): CurrentSiteService {
        return this.currentSiteService;
    }
    public get CurrentFolderService(): CurrentFolderService {
        return this.currentFolderService;
    }
    public get FormInstanceService(): FormInstanceService {
        return this.formInstanceService;
    }
    public get FolderService(): FolderService {
        return this.folderService;
    }
    public get CommunicationService(): CommunicationService {
        return this.communicationService;
    }
    public get DeleteOnConfirmDialogService(): DeleteOnConfirmDialogService {
        return this.deleteOnConfirmDialogService;
    }

    public get FormFiller(): FormFillerComponent {
        return this.formFiller;
    }
    public get FormRenderer(): FormRendererComponent {
        return this.formFiller != null ? this.formFiller.FormRenderer : null;
    }
    public get SelectedFolder(): Folder {
        return this.selectedFolder;
    }
    public set SelectedFolder(value: Folder) {
        this.selectedFolder = value;
    }
    public get SelectedFormInstance(): FormInstance {
        return this.selectedFormInstance;
    }
    public set SelectedFormInstance(value: FormInstance) {
        this.selectedFormInstance = value;
    }
    public get DetailsMode(): string {
        return this.detailsMode;
    }
    public set DetailsMode(value: string) {
        this.detailsMode = value;
    }
    public get RoleService(): RoleService {
        return this.roleService;
    }
    public get ViewAndManageRolesButtonConfig(): ViewAndManageRolesButtonConfig {
        return this.viewAndManageRolesButtonConfig;
    }
    public set ViewAndManageRolesButtonConfig(value: ViewAndManageRolesButtonConfig) {
        this.viewAndManageRolesButtonConfig = value;
    }
    public get ComponentHierarchyService(): ComponentHierarchyService {
        return this.componentHierarchyServiceForMenuClass;
    }

    public get DrawerComponentLiaison(): IDrawerComponentLiaison {
        return this.drawerComponentLiaison;
    }
    public set DrawerComponentLiaison(value: IDrawerComponentLiaison) {
        this.drawerComponentLiaison = value;
    }

    public get FolderPath(): string[] {
        return this.treeProperties.folderPath;
    }
    public set FolderPath(value: string[]) {
        this.treeProperties.folderPath = value;
    }

    //VNEXT-310: KLW - New method to update the form instance 
    public updateFormInstance(event) {
        this.CurrentFormInstance = event;
    }

    public droppedFiles(event: DragEvent) {

        UtilityHelper.allowDrop(event);

        let fileList: File[] = Array.from(event.dataTransfer.files);
        let folderId: number = this.currentFolder.getId();
        if (fileList.length > 0) {
            let toPass: FilesDroppedOnStructureEvent = new FilesDroppedOnStructureEvent(fileList);
            toPass.setToDropFolderId(folderId);
            toPass.setObjectType(DragDropEnum.FORM);
            toPass.setReload(true);
            console.log(event);
            this.onFileDropped(toPass);
        }
    }

    public blockDrop(ev: DragEvent) {
        UtilityHelper.blockDrop(ev);
    }

    public allowDrop(ev) {
        UtilityHelper.allowDrop(ev);
    }

    public get TypeSortOrderConfig(): string[] {
        return [ItemTypeEnum.FOLDER, ItemTypeEnum.FORM_INSTANCE];
    }

    public onFileDropped(event: FilesDroppedOnStructureEvent): void {
        this.folderService.get(event.getToDropFolderId()).then((folder) => {
            let reload = event.getReload();
            event.setFolderName(folder.name);

            let dialogConfig: MatDialogConfig = new MatDialogConfig();
            dialogConfig.hasBackdrop = true;
            dialogConfig.width = '500px';
            dialogConfig.data = event;

            const dialogRef = this.dialog.open(ImportDragDropComponent, dialogConfig);

            dialogRef.afterClosed().subscribe(importedFormId => {
                if (((importedFormId != null) && (importedFormId > 0)) || reload) {
                    this.reloadStructure();
                }
            });
        });

        return;
    }

    // When closing history, make sure to re-display the Original FormInstance and not a Version
    public onCloseHistory(originalFormInstanceId: number) {
        this.showHistory = false;
    }

    public onFormInstanceRestore(fi: FormInstance): void {
        this.ShowHistory = false;
        this.loadFormInstance(fi.originalFormInstanceId);
    }

    public onViewFormInstanceVersion(fi: FormInstance) {
        this.ShowHistory = false;
        this.loadFormInstance(fi.id, true);
    }

    public get ColumnsConfig(): string[] {
        return ['select', 'name', 'modifiedDate', 'modifiedBy', 'status'];
    }

    public userCanControlPermissionsInheritance(folder: Folder) {
        return folder.canGrant && folder.canBuildFolders;
    }

    // implement the HasUnsavedChanges interface and protect against an unload with unsaved changes
    @HostListener('window:beforeunload', ['$event'])
    handleBeforeUnload($event: any) {
        //VNEXT-951: KLW - Changes to bypass leave site pop-up warning
        if (this.currentUserService.userIsLoggedIn && this.hasUnsavedChanges() && !this.hasBypassSitePopUpWarning()) {
            $event.returnValue = "You have unsaved changes!";
        }
    }
    public hasUnsavedChanges(): boolean {
        if (environment.suppressUnsavedChangesWarning) {
            return false;
        }
        if (this.currentFormInstance == null) {
            return false;
        } else {
            return this.formFiller?.hasUnsavedChanges();
        }
    }

    // pharvey - prevents conflict when name edited and then form is saved
    public handleFormInstanceNameChange(event: FormInstance) {
        this.currentFormInstance.rowVersion = event.rowVersion;
    }

    //VNEXT-951: KLW - Changes to bypass leave site pop-up warning
    public hasBypassSitePopUpWarning(): boolean {
        if (environment.suppressUnsavedChangesWarning) {
            return false;
        }
        if (this.currentFormInstance == null) {
            return false;
        } else {
            return this.formFiller?.hasBypassSitePopUpWarning();
        }
    }

    public getSelectedType(): string {
        if (this.selectedFolder != null) {
            return FORM;
        } else if (this.selectedFormInstance != null) {
            return FORM_INSTANCE;
        } else {
            return null;
        }
    }

    public deselectSelected(): void {
        // PAUL NOTE:  DISCUSS THE FOLLOWING WITH PAUL.
        if (this.RolesTargetFolder != null) {
            this.viewAndManageRolesButtonConfig.updateSelfManagedFolders(this.RolesTargetFolder);
        }

        this.selectedFolder = null;
        this.selectedFormInstance = null;

        this.drawerComponentLiaison = null;
    }

    // Returns the id of the selected Form OR Folder, or null if none are selected
    public getSelectedId(): number {
        if (this.selectedFolder != null) {
            return this.selectedFolder.id;
        } else if (this.selectedFormInstance != null) {
            return this.selectedFormInstance.id;
        } else if (this.RolesTargetFolder) {
            return this.RolesTargetFolder.id;
        }
        else {
            return null;
        }
    }

    public deselectRolesTargetFolder(folder: Folder): void {
        return;
    }

    public get FavoriteDrawerTitle(): string {
        let title: string = '';

        if (this.selectedFolder) {
            title = 'Folder Favorite';
        } else if (this.selectedFormInstance) {
            title = 'Form Favorite';
        }

        return (title);
    }

    public get IsFavorite(): boolean {
        let bIsFavorite: boolean = false;

        if (this.selectedFolder) {
            bIsFavorite = this.selectedFolder.isFavorite;
        } else if (this.selectedFormInstance) {
            bIsFavorite = this.selectedFormInstance.isFavorite;
        }

        return (bIsFavorite);
    }

    public get FavoriteTitle(): string {
        let favTitle: string = '';

        if (this.selectedFolder) {
            if (this.selectedFolder.isFavorite &&
                this.selectedFolder.favoriteTitle &&
                (this.selectedFolder.favoriteTitle.trim() !== '')) {
                favTitle = this.selectedFolder.favoriteTitle;
            } else {
                favTitle = this.selectedFolder.name;
            }
        } else if (this.selectedFormInstance) {
            if (this.selectedFormInstance.isFavorite &&
                this.selectedFormInstance.favoriteTitle &&
                this.selectedFormInstance.favoriteTitle.trim() !== '') {
                favTitle = this.selectedFormInstance.favoriteTitle;
            } else {
                favTitle = this.selectedFormInstance.name;
            }
        }

        return (favTitle);
    }

    public doOnItemAction(eventData: any): void {
        StructureComponent.callButtonClickHandler(eventData.button, eventData.value, eventData, eventData.item);
    }

    public doShowTree(eventData: any): void {
        if (!this.folderTreeService.ShowTree) {
            this.folderTreeService.toggleTreePinnedState();
        }
    }

    public doHideTree(eventData: any): void {
        if (this.folderTreeService.ShowTree) {
            this.folderTreeService.toggleTreePinnedState();
        }
    }

    public displayEntity(eventData: any): void {
        this.listViewLiaison.displayEntity(eventData);
    }

    private doOnDetailsFolderRetrievedArrowFunction = (f: Folder): void => {
        this.selectedFolder = f;

        AccessibilityHelper.setFocus('#details-drawer-keyboard-focus-div');

        return;
    }

    private doOnDetailsFormInstanceRetrievedArrowFunction = (fi: FormInstance): void => {
        this.selectedFormInstance = fi;

        AccessibilityHelper.setFocus('#details-drawer-keyboard-focus-div');

        return;
    }

    public doOnFavorite(listItem: IListItem): void {
        this.detailsMode = VIEW;
        this.selectedFormInstance = null;
        this.selectedFolder = null;

        if (listItem.getType() == FOLDER) {
            this.folderService.get(listItem.getId()).then(f => {
                this.selectedFolder = f;

                AccessibilityHelper.setFocus('#details-drawer-keyboard-focus-div');
            });
        } else if (listItem.getType() == FORM_INSTANCE) {
            this.formInstanceService.get(listItem.getId()).then(f => {
                this.selectedFormInstance = f;
                AccessibilityHelper.setFocus('#details-drawer-keyboard-focus-div');
            });
        }

        return;
    }

    public doOnDragActionToStructure(event: ListItemDragActionData) {
        if (this.ColumnSortingIsOff) {
            this.draggedItems = event;
        }
    }

    public setSelections(items: IListItem[]) {
        this.selectedItems = items;
    }

    // pharvey 12/17/2021 - Moved the guts of moving List Items from BaseViewComponent to here since
    // it all relates to movement within structure and contains a lot of references
    // to Structure specific stuff.
    public doOnItemMoved(moveData: ListItemMoveData, movedViaTree: boolean = false) {
        if (moveData.NothingMoved) {
            return null;
        }

        let movedItems = moveData.MovedItems;
        let targetItem = moveData.TargetOfMove;

        let errorMsg = this.getErrorMessage(movedItems, targetItem);
        if (errorMsg) {
            alert(errorMsg);
            return;
        }

        // If target is a Folder and moved is a single Folder:                            PROMPT move or reposition
        // If target is a Folder and moved is not a single Folder:                        PROMPT move
        // If target is a FormInstance and moved is not a single FormInstance             DO NOTHING
        // If target is a FormInstance and moved is single FormInstance                   REPOSITION

        let oneItemMoved = movedItems.length == 1;
        let targetIsFolder = UtilityHelper.isTypeFolder(targetItem);
        let oneFolderMoved = oneItemMoved && UtilityHelper.isTypeFolder(movedItems[0]);
        let targetIsFormInstance = UtilityHelper.isTypeFormInstance(targetItem);
        let oneFormInstanceMoved = oneItemMoved && UtilityHelper.isTypeFormInstance(movedItems[0]);
        let showMoveOrRepositionPrompt = !movedViaTree && targetIsFolder && oneFolderMoved;
        let targetIsBreadcrumb = UtilityHelper.isTypeBreadcrumb(targetItem);
        let idsAndNewPositions: any = null;

        if (targetIsFormInstance && oneFormInstanceMoved) {
            if (this.cannotSortAlertTriggered()) return;

            let movedItem = movedItems[0];
            idsAndNewPositions = this.getNewPositionsForType(movedItem, targetItem, FormInstance.TypeName);
            this.moveItems(movedItems, targetItem, idsAndNewPositions);
        } else if (moveData.Reorder) {
            if (this.cannotSortAlertTriggered()) return;

            let movedItem = movedItems[0];
            idsAndNewPositions = this.getNewPositionsForType(movedItem, targetItem, Folder.TypeName);
            this.moveItems(movedItems, targetItem, idsAndNewPositions);
        } else {
            this.confirmMove(moveData.MovedItemsNames, targetItem.name, showMoveOrRepositionPrompt, (action) => {
                if (action == 'move') {
                    this.moveItems(movedItems, targetItem);
                }
            });
        }
    }

    private cannotSortAlertTriggered(): boolean {
        if (!this.ColumnSortingIsOff) {
            alert(this.getColumnSortingMessage());
            return true;
        } else {
            return false;
        }
    }

    private getColumnSortingMessage(): string {
        let currentSort = this.ColumnSortingConfig.active;
        return 'Your view is currently sorted by the "' + currentSort + '" column. In order to reposition this Item, turn sorting off and try again.';
    }

    private getErrorMessage(movedItems, targetItem) {
        let targetIsFolder = UtilityHelper.isTypeFolder(targetItem);
        let targetIsFormInstance = UtilityHelper.isTypeFormInstance(targetItem);

        let movedItemsCount = movedItems.length;
        let movedFoldersCount = movedItems.filter(x => { return UtilityHelper.isTypeFolder(x) }).length;
        if (targetIsFormInstance && movedItemsCount > 1) {
            return "You can only one Form at a time!";
        } else if (targetIsFormInstance && movedFoldersCount != 0) {
            return "You cannot drop Folders on Forms!"
        }
    }

    public moveItems(movedItems: IListItem[], targetOfMove: IListItem, idsAndNewPositions: any = null) {
        let folderId: number;
        let itemsToPass: IListItem[];
        let isReorderingMove = idsAndNewPositions != null;

        if (UtilityHelper.isTypeFolder(targetOfMove)) {
            if (isReorderingMove) {
                folderId = targetOfMove.getParentId();
            } else {
                folderId = targetOfMove.getId();
            }
        } else if (UtilityHelper.isTypeBreadcrumb(targetOfMove)) {
            folderId = targetOfMove.getId();
        } else if (UtilityHelper.isTypeFormInstance(targetOfMove)) {
            folderId = targetOfMove.getParentId();
        }

        this.moveEntity(movedItems, folderId, idsAndNewPositions);
    }

    // Figures out the new positions for all Items of the same type (Folders or FormInstances) based on where movedItem was moved to
    // Return is an object literal of the form {<id of item>:position, etc... } for example {123:0, 234:1, 345:3, etc ...}
    public getNewPositionsForType(movedItem: IListItem, targetItem: IListItem, type: string): any {
        let idOfMovedItem = movedItem.getId();
        let idOfTargetItem = targetItem.getId();

        let oldIndex = -1, newIndex = -1;
        let allItemsOfType = this.listItems.filter((item) => item.getType() == type);
        let otherItemsOfType = allItemsOfType.filter((item) => { return item.getId() != idOfMovedItem; });

        // find old and new index
        for (let i = 0; i < allItemsOfType.length; i++) {
            let item = allItemsOfType[i];
            let id = item.getId();
            if (id == idOfMovedItem) {
                oldIndex = i;
            } else if (id == idOfTargetItem) {
                newIndex = i;
            }
        }

        // create reordered array
        // see https://medium.com/kevin-salters-blog/reordering-a-javascript-array-based-on-a-drag-and-drop-interface-e3ca39ca25c
        let reordered = [
            ...otherItemsOfType.slice(0, newIndex),
            movedItem,
            ...otherItemsOfType.slice(newIndex)
        ];

        let idsAndNewPositions = {}, namesAndNewPosition = {}; // namesAndNewPosition not used but useful for debug
        for (let i = 0; i < reordered.length; i++) {
            let item = reordered[i];
            idsAndNewPositions[item.getId()] = i;
            namesAndNewPosition[item.name] = i;
        }

        return idsAndNewPositions;
    }

    // Displays a dialog box for user to confirm their intention to move the given List Items and, if relevant, to choose between
    // a "move into" move vs. a "reposition" move.
    public confirmMove(movedNodes: string[], newParentNode: string, showMoveOrRepositionPrompt: boolean, callback: Function) {
        let desc = '';
        let title = 'Move Item';
        desc = 'Are you sure you want to move the item';

        if (movedNodes.length > 1) {
            title += 's';
            desc += 's:\n\n';
        }
        else {
            desc += ':\n\n';
        }

        movedNodes.forEach(x => {
            desc += x + '\n';
        });

        desc += '\n';

        desc += `into Folder "${newParentNode}"?\n`;
        let repositionDisabledMsg = null;
        if (!this.ColumnSortingIsOff) {
            repositionDisabledMsg = this.getColumnSortingMessage();
        }
        let dialogRef = this.dialog.open(MoveListItemDialog, { data: { message: desc, showMoveOrRepositionPrompt: showMoveOrRepositionPrompt, repositionDisabledMsg: repositionDisabledMsg } });

        dialogRef.afterClosed().subscribe(data => {
            callback(data);
        });
    }

    private moveEntity(items: IListItem[], folderId: number, reorderedItems: any) {

        let promises: Promise<any>[] = [];

        let retVal = new Promise((resolve, reject) => {

            items.forEach((item) => {
                if (UtilityHelper.isTypeFormInstance(item)) {

                    let formInstancePromise = this.moveFormInstanceServiceCall(item.getId(), folderId, reorderedItems).then(response => {
                        resolve(item.getId());
                    });

                    promises.push(formInstancePromise);
                }

                if (UtilityHelper.isTypeFolder(item)) {
                    let folderPromise = this.moveFolderServiceCall(item.getId(), folderId, reorderedItems).then(response => {
                        resolve(item.getId());
                    });

                    promises.push(folderPromise);
                }
            });
        });

        Promise.all(promises).then((x) => {
            this.reloadStructure();
            this.forceTreeRedraw();
            AccessibilityHelper.setFocus('#details-drawer-keyboard-focus-div');
        });
    }

    public doOnItemDeleted(eventData: TrashDeleteEvent) {
        this.listViewLiaison.doOnItemDeleted(eventData);
    }

    public deleteFormInstanceServiceCall(formInstance: FormInstance): Promise<boolean> {
        let url: string = this.returnPath();

        return new Promise<boolean>((resolve) => {
            this.router.navigateByUrl(url).then(x => {
                this.formInstanceService.delete(formInstance.id).then(x => {
                    resolve(true);
                });
            });
        });
    }

    public deleteFolderServiceCall(folder: Folder): Promise<boolean> {
        let url: string = this.returnPath();

        return new Promise<boolean>((resolve) => {
            this.router.navigateByUrl(url).then(x => {
                this.folderService.delete(folder.id).then(x => {
                    resolve(true);
                });
            });
        });
    }

    public moveFormInstanceServiceCall(formInstanceId: number, folderId: number, reorderedItems: any): Promise<boolean> {
        let url: string = this.returnPath();

        return new Promise<boolean>((resolve) => {
            this.router.navigateByUrl(url).then(x => {
                if (reorderedItems) {
                    this.folderService.reorderFormInstances(reorderedItems, folderId).then(x => {
                        resolve(true);
                    });
                } else {
                    this.folderService.moveFormInstance(formInstanceId, folderId).then(x => {
                        resolve(true);
                    });
                }
            });
        });
    }

    public moveFolderServiceCall(movedFolderId: number, parentFolderId: number, reorderedItems: any): Promise<boolean> {
        let url: string = this.returnPath();

        return new Promise<boolean>((resolve) => {
            this.router.navigateByUrl(url).then(x => {
                if (reorderedItems) {
                    this.folderService.reorderChildFolders(reorderedItems, parentFolderId).then(x => {
                        resolve(true);
                    });
                } else {
                    this.folderService.moveFolders([movedFolderId], parentFolderId).then(x => {
                        resolve(true);
                    });
                }
            });
        });
    }

    // Handler for a right-click in the space below the ListView (to allow pasting at the level of the current Folder)
    public onMainPanelContextMenu(event: any): void {
        event.preventDefault();
        event.stopPropagation();

        let x = event.clientX + 'px';
        let y = event.clientY + 'px';
        if (this.mainPanelContextMenuComponent != null)
            this.mainPanelContextMenuComponent.openMenuForItemAt(this.currentFolder, x, y);
    }

    // Handler for a right-click of the ListView componnent itself (not of a ListItem within it)
    public onListViewContextMenu(event: any): void {
        event.preventDefault();
        event.stopPropagation();

        // Set the context menu position.
        let pageContextMenuPositionX = event.clientX + 'px';
        let pageContextMenuPositionY = event.clientY + 'px';
        if (this.listViewContextMenuComponent != null)
            this.listViewContextMenuComponent.openMenuForItemAt(this, pageContextMenuPositionX, pageContextMenuPositionY);
    }

    // Handler for a right-click of a Form or Folder in the ListView
    public onListViewItemContextMenu(event: any): void {
        // Set menu data.
        let itemContextMenuPositionX = event.originalEvent.clientX + 'px';
        let itemContextMenuPositionY = event.originalEvent.clientY + 'px';
        if (this.listViewItemContextMenuComponent != null)
            this.listViewItemContextMenuComponent.openMenuForItemAt(event.item, itemContextMenuPositionX, itemContextMenuPositionY);

        return;
    }

    public sendNotification(eventData: any): void {
        let contextItem: IListItem = this.listViewItemContextMenuComponent.ContextItem;
    }

    public reloadCurrentFolder() {
        let url: string = `/site/${this.site.id}/structure/folder/${this.currentFolder.id}`;
        this.currentFolderService.Folder = null;
        this.router.navigateByUrl(url);
    }

    public doOnScheduleEventForItemClick(eventData: any): void {
        // Launch a schedule event dialogue.
        let itemType: string = this.listViewItemContextMenuComponent.ContextItem.getType();

        let dialogConfig: MatDialogConfig = new MatDialogConfig();
        dialogConfig.hasBackdrop = true;
        dialogConfig.width = '800px';
        dialogConfig.height = '750px';
        dialogConfig.data = this.listViewItemContextMenuComponent.ContextItem;

        const dialogRef = this.dialog.open(ScheduledEventsDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(scheduledEventDef => {

        });
    }

    // 8/7/2024 note - there don't appear to be any calls to this - can it be deleted?
    public doOnExportStructureInstance(eventData: any): void {
        // Process an export structure instances dialogue
        //
        // Note:  presently this dialogue only exports
        //        form instances.
        let contextMenuItem: IHasIdAndName = this.listViewItemContextMenuComponent.ContextItem;
        let formInstance: FormInstance = <FormInstance>contextMenuItem;

        let dialogConfig: MatDialogConfig = new MatDialogConfig();
        dialogConfig.hasBackdrop = true;
        dialogConfig.width = '500px';

        let exportDataConfig: ExportDataDialogConfig = new ExportDataDialogConfig();
        exportDataConfig.action = ExportDataDialogAction.ExportFormInstance;
        exportDataConfig.objectId = formInstance.id;
        dialogConfig.data = exportDataConfig;

        const dialogRef = this.dialog.open(ExportDataDialog, dialogConfig);
        dialogRef.afterClosed().subscribe(exportedFormInstance => {
            // Note:  nothing more to do here by design.
        });
    }

    public drawerClosing(): void {
        this.drawerComponentLiaison = null;
    }

    private doOnImportStructureInstances(): void {
        this.listViewLiaison.doOnImportStructureInstances();
    }

    private doOnImportDataFiles(): void {
        this.listViewLiaison.doOnImportDataFiles();
    }

    public doOnExportDataFiles(): void {
        // Note:  this method current performs a full site export.
        //
        // Note:  we will likely allow the user to choose between
        //        a full site export or a more limited export in
        //        the future.
        let dialogConfig: MatDialogConfig = ExportSiteDialog.createDialogConfig(this.currentSiteService.Site);
        const dialogRef = this.dialog.open(ExportSiteDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(exportedSiteDownloadUrl => {
            if (exportedSiteDownloadUrl != null) {
                // Note:  the following call to window.open() is not working.
                //window.open(exportedSiteDownloadUrl, "_blank");
            }
        });
    }

    public doOnExportToExcel(): void {
        let currentFolder: Folder = this.currentFolderService.Folder;

        let dialogueData: ExportFormDataDialogConfig = new ExportFormDataDialogConfig(ExportFormDataDialogAction.ExportFolderFormData, currentFolder.id, currentFolder.dataCollectionId);

        let dialogConfig: MatDialogConfig = new MatDialogConfig();
        dialogConfig.hasBackdrop = true;
        dialogConfig.width = '500px';
        dialogConfig.data = dialogueData;
        const dialogRef = this.dialog.open(ExportFormDataDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(downloadUrl => {
            // Note:  nothing to do here by design.
        });
    }

    public doOnSaveFormInstance(): void {
        if (this.formFiller != null) {
            this.formFiller.saveRenderer();
        }
    }

    // Reset wasn't working, so quick and dirty fix (this is how the FormRendererComponent does a reset. Should really cache a FormInstance on load and use that to reset)
    public doOnResetFormInstance(): void {
        this.formInstanceService.getContent(this.currentFormInstance.id, false, "Resetting Form...").then(res => {
            this.currentFormInstance = res;

            let hshEventData = { formInstance: this.currentFormInstance };
            this.formFiller.onFormInstanceReset(hshEventData);
        });
    }

    public doOnPrintFormInstance(): void {
        window.print();
    }

    public deleteEntity(entity: any) {
        if (entity instanceof Folder) {
            this.deleteFolder(entity);
        } else if (entity instanceof FormInstance) {
            this.deleteFormInstance(entity);
        }
    }

    public deleteFolder(folder: Folder): void {
        this.deleteOnConfirm("Folder", () => {
            let url: string = `/site/${this.site.id}/structure/${folder.parentFolderId}`;
            this.folderService.delete(folder.id).then(x => {
                let newList = this.listItems.filter(item => {
                    return item.getId() !== folder.id;
                });
                this.listItems = newList;
                this.selectedFolder = null;

                // In case the folder tree is
                // being shown, force it to redraw.
                this.forceTreeRedraw();
            });
        });
    }


    public deleteFormInstance(formInstance: FormInstance): void {
        let url: string = this.returnPath();
        this.router.navigateByUrl(url).then(x => {
            this.deleteOnConfirm("Form Instance", () => {
                this.formInstanceService.delete(formInstance.id).then(x => {
                    let formId = formInstance.id;
                    let newList = this.listItems.filter(item => {
                        return item.getId() !== formId;
                    });
                    this.listItems = newList;
                    this.selectedFormInstance = null;

                    // In case the folder tree is
                    // being shown, force it to redraw.
                    this.forceTreeRedraw();
                });
            })
        });
    }

    public transitionFormInstance(formInstance: FormInstance): void {
        this.formInstanceService.transitionWorkflowState(formInstance).then(response => {
            this.selectedFormInstance = response;
            IListItemManager.findAndUpdateFrom(this.listItems, this.selectedFormInstance);
            this.deselectSelected();
        });
    }

    public updateWorkflowState(folder: Folder): void {
        this.treeProperties.treeIsStale = false;
        this.folderService.transitionFolder(folder).then(response => {
            this.selectedFolder = response;
            IListItemManager.findAndUpdateFrom(this.listItems, this.selectedFolder);
            UtilityHelper.findAndAssignFrom(this.currentFolder.childFolders, this.selectedFolder);
            this.forceTreeRedraw();
            this.deselectSelected();
        });
    }

    saveToggledFavorite(favoriteInfoParam: FavoriteInfo): void {
        // Save the specified "is favorite" value.
        if (this.selectedFolder) {
            this.selectedFolder.isFavorite = favoriteInfoParam.isFavorite;
            this.selectedFolder.favoriteTitle = favoriteInfoParam.favoriteTitle;

            // Update the folder's favorite status.
            this.folderService.updateIsFavorite(this.selectedFolder).then(updatedFolder => {
                // Also update the button config.
                this.favoritesButtonConfig.updateFolderFavoriteStatus(updatedFolder);
            });
        } else if (this.selectedFormInstance) {
            this.selectedFormInstance.isFavorite = favoriteInfoParam.isFavorite;
            this.selectedFormInstance.favoriteTitle = favoriteInfoParam.favoriteTitle;

            // Update the form instance's favorite status.
            this.formInstanceService.updateIsFavorite(this.selectedFormInstance).then(updatedFormInstance => {
                // Also update the button config.
                this.favoritesButtonConfig.updateFormInstanceFavoriteStatus(updatedFormInstance);
            });
        }

        // to dismiss the drawer.
        this.hideToggleFavorite();

        return;
    }
    hideToggleFavorite(): void {

        this.deselectSelected();

        return;
    }

    // Note:  each of the following blocks can be rolled into its own class as we have now done
    //        with the context menu item classes.
    //
    //        An instance of the class that corresponds to one of the code blocks below can be
    //        associated with the ButtonConfig instance that is triggering a call to this method.
    //        That handler instance can be passed to this method and then simply called here
    //        instead of using a very large if-then-else statement.
    public doOnButtonClick(eventData: any): void {
        let useButtonClickHandler: boolean = false;
        let contextItem = null;

        if (eventData.button == HISTORY) {
            this.showHistory = true;
        } else if (eventData.button == SUBSCRIBE) {
            useButtonClickHandler = true;
        } else if (eventData.button == PUBLISH) {
            useButtonClickHandler = true;
        } else if (eventData.button == FOLDER) {
            useButtonClickHandler = true;
        } else if (eventData.button == FORM) {
            useButtonClickHandler = true;
        } else if (eventData.button == UP_ONE_LEVEL) {
            useButtonClickHandler = true;
        } else if (eventData.button == TREE) {
            useButtonClickHandler = true;
        } else if (eventData.button == IMPORT_FORM_INSTANCE_DATA) {
            this.doOnImportStructureInstances();
        } else if (eventData.button == IMPORT_FORM_INSTANCE_FILES) {
            this.doOnImportDataFiles();
        } else if (eventData.button == EXPORT_FORM_INSTANCE_FILES) {
            useButtonClickHandler = true;
        } else if (eventData.button == EXPORT_TO_EXCEL) {
            useButtonClickHandler = true;
        } else if (eventData.button == SAVE_FORM_INSTANCE) {
            useButtonClickHandler = true;
        } else if (eventData.button == RESET_FORM_INSTANCE) {
            useButtonClickHandler = true;
        } else if (eventData.button == PRINT_FORM_INSTANCE) {
            contextItem = eventData.buttonConfig.buttonClickHandler.structureComponent.currentFormInstance;
            useButtonClickHandler = true;
        } else if (eventData.button == BULK_WORKFLOW) {
            useButtonClickHandler = true;
        } else if (eventData.button == FORM_DETAILS) {
            contextItem = eventData.buttonConfig.buttonClickHandler.structureComponent.currentFormInstance;
            useButtonClickHandler = true;
        } else {
            console.log("StructureComponent#doOnButtonClick() ==> Unknown Operation!");
        }

        // Use the button click handler?
        if (useButtonClickHandler)
            StructureComponent.callButtonClickHandler(eventData.buttonConfig, eventData.button, eventData, contextItem);
    }

    private static callButtonClickHandler(buttonConfig: IButtonConfig, buttonName: string, eventData: any, contextItem: any = null): void {
        let buttonConfigClickHandler: IButtonConfigClickHandler = (buttonConfig != null ? buttonConfig.buttonClickHandler : null);

        if (buttonConfig == null) {
            let errorMsg = `StructureComponent.doOnButtonClick():  there is not button config for button '${buttonName}'.`;
            throw errorMsg;
        } else if (buttonConfigClickHandler == null) {
            let errorMsg = `StructureComponent.doOnButtonClick():  there is not button click handler for button '${buttonName}'.`;
            throw errorMsg;
        }

        buttonConfigClickHandler.handlePreButtonClick(); // Note:  it is important to call this method before calling handleButtonClick().
        buttonConfigClickHandler.handleButtonClick(buttonConfig, eventData, contextItem);
    }

    private trackPageView() {
        let title = null;
        if (this.currentFolder.parentFolderId == null) { 
        }
        else {
            title = this.currentFormInstance != null ? 'Form' : 'Folder'; 
        }
    }

    public updateDisplayOfEntity(entity: any = null) {
        let list = Object.assign([], this.listItems);
        let treeNodeKey;

        if (entity != null) {
            if (entity instanceof Folder) {
                this.currentFolder.childFolders.push(entity);
                treeNodeKey = `folder_${entity.id}`;
            } else {
                this.currentFolder.formInstances.push(entity);
                treeNodeKey = `form-instance_${entity.id}`;
            }

            let li: IListItem = entity;
            list.push(li);
        }

        this.listItems = list; // this is needed because the GridView requires listItems to be replaced not just modified in place
        this.forceTreeRedraw(treeNodeKey);

        // Need to reload scriptable elements as well.
        super.reFindScriptableElements(); // For UI testing
    }

    // note that no sorting information is passed here, rather ListView takes care of
    // registering sort info in browser local storage (as it always has) and this is
    // retrieved by the service call that's made in handleLoadMore(). Therefore all we need
    // to do is call handleLoadMore with an offset of zero and it will do a brand new fetch
    // from the server with requested sorting
    public handleSortChange(event: any) {
        console.log('Structure.handleSortChange()');
        this.handleLoadMore(event, 0, true);
    }

    public handleLoadMore($event, startAt = null, sortChange = false) {
        let list;
        if (startAt == null) {
            startAt = this.ListItems.length;
            list = Object.assign([], this.listItems);
        } else {
            list = [];
        }

        this.folderService.getWithPagination(this.currentFolder.id, true, startAt).then(folder => {
            this.updateListItems(folder, list, sortChange);
        });
    }

    public handleFilterTermChange(term: any) {
        this.filterTerm = term;

        let list = [];

        this.folderService.getWithPagination(this.currentFolder.id, true, 0, ListViewHelper.PAGE_SIZE, term).then(folder => {
            this.updateListItems(folder, list, true);
            if (!term) this.structureReset(); // if term is false that means user has blanked out the filter field meaning we just fetched first page full dataset afresh
        });
    }

    private updateListItems(folder: Folder, list: any, startOver = false) {
        this.totalListCount = folder.totalChildFolderCount + folder.totalFormInstanceCount;
        folder.childFolders.forEach(f => {
            let folderAlreadyInList = this.listItems.filter(listItem => {
                return listItem.getId() == f.id && listItem.getType() == FOLDER;
            }).length > 0;

            if (!folderAlreadyInList || startOver) {
                let folder = Object.assign(new Folder(), f);
                list.push(folder);
                this.currentFolder.childFolders.push(folder);
            }
        });
        folder.formInstances.forEach(fi => {
            let formInstanceAlreadyInList = this.listItems.filter(listItem => {
                return listItem.getId() == fi.id && listItem.getType() == FORM_INSTANCE;
            }).length > 0;

            if (!formInstanceAlreadyInList || startOver) {
                list.push(Object.assign(new FormInstance(), fi));
            }
        });
        this.listItems = list;
        this.structureReset();
    }

    // pharvey ~ 10/9/2021 ~ I haven't got to the bottom of this, but change detection was not reliably kicking in unless I updated
    // structureResetAt when the stack is clear. (Not only that, change detection didn't kick in at all when the variable was a boolean, hence I switched to a Date force detection)
    public structureReset() {
        UtilityHelper.runWhenStackClear(() => {
            this.structureResetAt = new Date();
            this.setupButtonConfigForListItems();
        });
    }

    private setRootFolder() {
        if (this.currentFolder.parentFolderId == null) {
            this.rootFolder = this.currentFolder;
        }
    }

    private setListItems(): void {
        let index = 0;
        let list: IListItem[] = [];
        this.currentFolder.childFolders.forEach(f => {
            f.itemIndex = index++;
            list.push(Object.assign(new Folder(), f));
        });
        this.currentFolder.formInstances.forEach(fi => {
            fi.itemIndex = index++;
            list.push(Object.assign(new FormInstance(), fi));
        });
        this.listItems = list;

        return;
    }

    public returnPath() {
        let folderPath = this.route.snapshot.url.map((segment) => { return segment.path }).join('/');
        if (folderPath.length > 0) folderPath = '/' + folderPath;
        return `/site/${this.site.id}/structure${folderPath}`;
    }

    // Sets the this folderPath property which supplied as the [path] @Input to the tree and which the tree uses to expand to and highlight the selected node
    // This is needed to open the tree to the correct nodes as the user navigates in the folder list view
    private setFolderPathForTree(newId: string = null) {
        let ancestorIds =
            (this.currentFolder.ancestorFolders ?
                this.currentFolder.ancestorFolders
                    .filter(f => { return f.parentFolderId != null }) // filter out root folder
                    .map(f => { return f.id }) :
                []);

        if (!this.currentFolderIsRoot()) { ancestorIds.push(this.currentFolder.id); }
        // need to distinguish folder and forms for the tree
        let qualifiedAncestorIds = ancestorIds.map(id => { return `Folder_${id}` });
        if (newId != null) { qualifiedAncestorIds.push(newId) }
        if (this.currentFormInstance != null) {
            qualifiedAncestorIds.push(`FormInstance_${this.currentFormInstance.id}`)
        }
        this.treeProperties.folderPath = qualifiedAncestorIds;
    }

    private updateSkipNav() {
        let url = this.router.url;
        this.communicationService.emitChangeToSkipNavLink(url);
        AccessibilityHelper.focusOnMainContent();
    }

    private currentFolderIsRoot() {
        return this.rootFolder == this.currentFolder;
    }

    // treeIsStale is used to set an @Input property of the folder-tree component. It watches for changes to this 
    // property and redraws the tree when it changes from false to true. In addition this.folderPath is used to set
    // the tree component's path @Input, and so updating this causes the tree to expand to the desired node 
    public forceTreeRedraw(treeNodeKey: string = null) {
        this.treeProperties.treeIsStale = null;
        this.setFolderPathForTree(treeNodeKey);
        UtilityHelper.runWhenStackClear(() => {
            this.treeProperties.treeIsStale = true;
        });
    }

    // TODO: create a DialogService and put this in it.
    // 02-01-2021 note:  created DeleteOnConfirmDialogService,
    //                   an instance of which is used below.
    public deleteOnConfirm(entity: string, callback: Function) {
        this.deleteOnConfirmDialogService.deleteOnConfirm(this.dialog, entity, callback);

        return;
    }

    private loadFormInstance(id: number, isVersion: boolean = false) {
        let baseUrl = this.router.url.split('?')[0];  // remove query string
        let urlParts: any[] = baseUrl.split('/');
        urlParts.pop();
        urlParts.push(id);
        let url = urlParts.join('/');

        if (isVersion) {
            url = `${url}?isVersion=true`;
        }
        this.router.navigateByUrl(url, {});
    }

    public reloadStructure(reloadFolder: boolean = true): void {
        this.currentFolderService.nullifyCurrentFolder(); // enables a reload of current folder in FolderResolver (needed to allow UI to refresh))
        let url: string = this.router.url;

        // Are we showing a folder or a form instance?
        let urlParts: string[] = url.split('/');
        if (reloadFolder && urlParts.length >= 6) {
            const folderOrFormPart: string = urlParts[urlParts.length - 2];
            if (folderOrFormPart != 'folder') {
                urlParts.pop();
                urlParts.pop();
                url = urlParts.join('/');
            }
        }
        this.router.navigateByUrl(url, {});

        return;
    }

    // returns true of this.drawerComponentLiaison's HandlesDrawerComponentTag natches htmlTag
    private showDrawerWithTag(htmlTag: string): boolean {
        let show = ((this.drawerComponentLiaison != null) && (this.drawerComponentLiaison.HandlesDrawerComponentTag == htmlTag) && this.drawerComponentLiaison.LiaisonHasInitialized);

        return show;
    }

}
